import { Component, Input, OnInit } from '@angular/core';
import { LegFiJwtService } from 'app/services/auth/legfi-jwt.service';
import { JwtLegFiClaims } from 'app/services/auth/jwt-legfi-claims.model';
import moment from 'moment-timezone';
import { OrganizationService } from 'app/services/organization/organization.service';
import { Organization } from 'app/models/entities/organization';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FilterContainerComponent } from '../filter-container/filter-container.component';
import { DateService } from '../../../../../services/date/date.service';
import { DateFilter } from '../../../../../models/entities/date-filter';
import { FilteringService } from '../../../../../services/filtering.service';

@UntilDestroy()
@Component({
    selector: 'report-filter-multi-date-range',
    templateUrl: './multi-date-range.component.html',
    styleUrls: ['./multi-date-range.component.scss'],
})
export class MultiDateRangeComponent implements OnInit
{
    @Input()
    filters: DateFilter[] = null;

    @Input() defaultToFiscalYear: boolean = false;
    @Input() defaultToThisMonth: boolean = false;
    @Input() showNext: boolean = false;
    @Input() container: FilterContainerComponent;
    @Input() dateRanges: string[];

    isAdmin: boolean = false;

    fiscalStartMonth: number = 1;

    private jwt: JwtLegFiClaims;

    constructor(
            public _filteringService: FilteringService,
            private _organizationService: OrganizationService,
            public _dateService: DateService,
    ) {
    }

    ngOnInit() {
        this.jwt = LegFiJwtService.read();
        this.container?.register(this);
        let passedInFilters = true;
        if (this.filters === null) {
            passedInFilters = false;
            this.setDateRangeFilters();
        }

        this.isAdmin = this.jwt.admin || this.jwt.superUser;
        this._organizationService
                .getOrganizationById(null, ['profile'])
                .pipe(untilDestroyed(this))
                .subscribe((org: Organization) => {
                    this.fiscalStartMonth = org.profile.fiscalPeriodStart;
                    if (!passedInFilters && this.defaultToFiscalYear) {
                        this._filteringService.setThisFiscalYearDatePickers(
                                this.filters,
                                this.fiscalStartMonth,
                        );
                    }
                    if (this.defaultToThisMonth) {
                        this._filteringService.setThisMonthDatePickers(
                                this.filters,
                        );
                    }
                    this.container?.notifyReady(this);
                });
    }

    setDateRangeFilters() {
        const filters = [];

        for (const dateRange of this.dateRanges) {
            filters.push({
                title: dateRange + ' Date Range',
                startDate: moment().startOf('year'),
                endDate: moment().endOf('year'),
            });
        }

        this.filters = filters;
    }

    parentReloadReport() {
        this.container.reloadReport();
    }

    getCurrentFiscalYearDisplay(): string {
        return this._dateService.getCurrentFiscalYearDisplay(this.fiscalStartMonth);
    }
}
